import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/index.scss' // 重置样式
import './assets/iconfont/iconfont.css'
import element from 'element-plus'
import 'element-plus/theme-chalk/el-message.css'
import 'element-plus/theme-chalk/el-loading.css'
import 'element-plus/theme-chalk/el-message-box.css'
import * as ElIcons from '@element-plus/icons-vue'
import { vLoading } from 'element-plus/es/components/loading/src/directive'
import 'dayjs/locale/zh-cn' //中文
import locale from 'element-plus/lib/locale/lang/zh-cn' //中文
import directive from './directive'
const app = createApp(App)
app.use(directive)
app.directive('load', vLoading)
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}

// 去除控制台warn 警告
app.config.warnHandler = () => null

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}

for (const name in ElIcons) {
  app.component(name, (ElIcons as any)[name])
}

app.use(store).use(router).use(element, { locale }).mount('#app')
